import { createApi } from "../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { OnvifScanPollResponse } from "./onvifScanInterfaces";
import { useOnvifScanStore } from "../onvifScanStore/onvifScanStore";

const POLL_INTERVAL_MS = 3000;
// SSM-driven subnet scans are slower than the NVR refresh; give them 5 minutes.
const MAX_WAIT_MS = 5 * 60 * 1000;

/**
 * Poll GET /api/network-auto-discovery/{task_id}/ until the job resolves.
 * Writes results/errors straight into the OnvifScan store.
 */
export const pollOnvifScan = (taskId: string, startTime: number) => {
  const AxiosUI = createApi("");
  const { setHosts, setScanStatus, setErrorMessage } =
    useOnvifScanStore.getState();

  const finishFailed = (message: string) => {
    setErrorMessage(message);
    setScanStatus("failed");
  };

  if (Date.now() - startTime > MAX_WAIT_MS) {
    finishFailed("Scan timed out. Please try again.");
    return;
  }

  AxiosUI.get(`network-auto-discovery/${taskId}/`).then(
    (response: AxiosResponse<OnvifScanPollResponse>) => {
      const data = response.data || ({} as OnvifScanPollResponse);

      if (data.status === "success") {
        setHosts(data.result?.hosts ?? []);
        setScanStatus("success");
        return;
      }

      if (data.status === "failed") {
        finishFailed(data.detail || data.error || "Discovery job failed.");
        return;
      }

      // pending (or unknown) — keep polling
      setTimeout(() => pollOnvifScan(taskId, startTime), POLL_INTERVAL_MS);
    },
    (_reason: AxiosError) => {
      // Transient poll error — retry until the max wait elapses.
      setTimeout(() => pollOnvifScan(taskId, startTime), POLL_INTERVAL_MS);
    }
  );
};
